import '@/stylesheets/application.scss';

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import I18n from 'i18n-js';
import VueGtag from 'vue-gtag';
import actionCablePlugin from '@/functions/action_cable';

import { getTranslations, language } from '@/config/i18n';

import App from '@/components/app.vue';
import createAppRouter from '@/components/routes/app_router.js';
import gtagConfig from '@/functions/gtag_config';

import { RAILS_ENVIRONMENT } from '../config/constants';

async function createI18nPlugin() {
  const translations = await getTranslations();

  I18n.locale = language;
  I18n.translations = translations;

  return {
    install(app) {
      app.config.globalProperties.I18n = I18n;
      app.config.globalProperties.$t = I18n.t.bind(I18n);
    },
  };
}

let root = document.getElementById('app-root');
const router = createAppRouter();

createI18nPlugin().then((i18nPlugin) => {
  const app = createApp(App);

  app.use(createPinia())
    .use(i18nPlugin)
    .use(router)
    .use(actionCablePlugin)
    .mount(root);

  if (RAILS_ENVIRONMENT !== 'review') {
    app.use(VueGtag, gtagConfig, router);
  }
});
